// i18n
import { useTranslation } from 'react-i18next';

// mui
import { Link, Typography } from '@mui/material';

// props
export interface LinkEmailProps {
	email: string;
}

export const LinkEmail = ({ email }: LinkEmailProps) => {
	// hooks
	const { t } = useTranslation();

	if (email) {
		return (
			<Link href={`mailto:${email}`} sx={{ wordBreak: 'break-word' }} underline="hover">
				{email}
			</Link>
		);
	}

	return <Typography>{t('na')}</Typography>;
};
